import { useAuthInterceptor, useLanguageInterceptor, useOrgUnitInterceptor } from "@innoclouds/shared";
import axios from "axios";

const useAxios = () => {
	const domain = import.meta?.env?.MODE !== "https" ? import.meta.env.VITE_API_URL : "";
	const baseURL = `${domain}/api/`;

	//GET
	const axiosInstanceGet = axios.create({ baseURL, headers: { "Content-Type": "application/json" } });
	const axiosInstanceAuthenticationGet = axios.create({ baseURL, headers: { "Content-Type": "application/json" } });

	//POST
	const axiosInstancePost = axios.create({ baseURL, headers: { "Content-Type": "application/json" } });
	const axiosInstanceAuthenticationPost = axios.create({ baseURL, headers: { "Content-Type": "application/json" } });

	// Auth
	useAuthInterceptor(axiosInstanceAuthenticationGet);
	useAuthInterceptor(axiosInstanceAuthenticationPost);

	// Language
	useLanguageInterceptor(axiosInstanceGet);
	useLanguageInterceptor(axiosInstancePost);
	useLanguageInterceptor(axiosInstanceAuthenticationGet);
	useLanguageInterceptor(axiosInstanceAuthenticationPost);

	// Org Unit
	useOrgUnitInterceptor(axiosInstanceGet);
	useOrgUnitInterceptor(axiosInstancePost);
	useOrgUnitInterceptor(axiosInstanceAuthenticationGet);
	useOrgUnitInterceptor(axiosInstanceAuthenticationPost);

	return {
		axiosInstanceAuthenticationGet,
		axiosInstanceAuthenticationPost,
		axiosInstancePost,
		axiosInstanceGet,
	};
};

export default useAxios;
